import { render, staticRenderFns } from "./LayeredFilters.vue?vue&type=template&id=9161deec&"
import script from "./LayeredFilters.vue?vue&type=script&lang=js&"
export * from "./LayeredFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default,OpusTitle: require('/~/src/modules/opus/components/Title.vue').default,OpusRangeSlider: require('/~/src/modules/opus/components/Form/RangeSlider.vue').default,OpusCheckbox: require('/~/src/modules/opus/components/Form/Checkbox.vue').default,OpusAccordionItem: require('/~/src/modules/opus/components/AccordionItem.vue').default,OpusAccordion: require('/~/src/modules/opus/components/Accordion.vue').default})
